export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const splitCamelCaseWithAbbreviations = (s: string) => {
    return s.split(/([A-Z][a-z]+)/).filter(e => e);
}